import { render, staticRenderFns } from "./AboutPage.vue?vue&type=template&id=3ec72797&"
import script from "./AboutPage.vue?vue&type=script&lang=ts&"
export * from "./AboutPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports